import { render, staticRenderFns } from "./expertCon.vue?vue&type=template&id=40b075e4&scoped=true&"
import script from "./expertCon.vue?vue&type=script&lang=js&"
export * from "./expertCon.vue?vue&type=script&lang=js&"
import style0 from "./expertCon.vue?vue&type=style&index=0&id=40b075e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b075e4",
  null
  
)

export default component.exports